import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Container, Row, Col, Input, Spinner, Fade } from "reactstrap";
import { clientTypeConstants } from "../../constants/clientType.constants";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { cmsActions } from "../../../store/actions/cms/cms.action";
import { sourceTypes } from "../../../constants/cms/sourceType";
import Axios from "axios";
import "../../stage/style/StageStyle.css";
import { questionActions } from "../../../store/actions/question/question.action";
import { getKey } from "../../../helpers/UrlHelper";
import ChatMessageList from "../MessageList";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { ConnectionStatus } from "../../../digitalArena/components/fallbacks/ConnectionStatus";

class ChatModeratorLayout extends Component {
  state = {
    hubConnection: null,
    clientKey: "",
    clientResponses: [],
    defaultLanguage: "swe",
    connected: false,
    eventId: -1,
    code: "",
    showDialog: false,
    chatMessages: [],
    scroll: false,
    forceDisc: false,
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    const eventId = this.props.match.params.id;
    document.body.style.overflow = "hidden";
    if (isNaN(eventId)) {
      this.getEventId(eventId);
    } else {
      this.props.dispatch(questionActions.getAllQuestionsByEvent(eventId));
      this.setState({ eventId }, () => this.connectToHub());
    }
    const params = new URLSearchParams(this.props.location.search);
    const lang = params.get(getKey("lang", params));
    const code = params.get(getKey("code", params));
    if (lang) this.setState({ defaultLanguage: lang });
    if (code) this.setState({ code });
    // this.props.dispatch(templateActions.getDefaultTemplateByEvent(eventId));
    this.props.dispatch(cmsActions.setEnviroment(sourceTypes.INTERACTION, false));
  }
  componentDidUpdate(prevProps, prevState) {
    const { connecting, dismissConnectionLoss, forceDisc, connected } = this.state;

    if (connected == false && prevState.connected == true && connecting == false) {
      this.tryReconnect();
      this.counter = setInterval(() => this.setState({ countdown: this.state.countdown + 1 }), 1000);
    } else if (this.state.countdown >= 60 && !connected && prevState.connected == false) {
      this.setState({ countdown: 0, connecting: false });
      this.tryReconnect();
    } else if (connected == true && prevState.connected == false && !this.state.connecting && this.hubConnection && this.hubConnection.connectionState == 1) {
      if (this.counter) clearInterval(this.counter);

      this.setState({ countdown: 0 });
    }
  }
  tryReconnect = () => {
    if (!this.state.connected && !this.state.connecting) {
      this.connectToHub();
    }
  };
  onMessageEdit = (res) => {
    const { chatMessages } = this.state;
    const resChat = chatMessages.find((c) => c.messages.find((m) => m.interactionChatId == res.id));
    if (resChat) {
      let index = chatMessages.indexOf(resChat);
      let messageIndex = resChat.messages.indexOf(resChat.messages.find((r) => r.interactionChatId == res.id));
      if (index > -1 && messageIndex > -1) {
        chatMessages[index].messages[messageIndex].message = res.message;
        this.setState({ chatMessages });
      }
    }
  };
  onMessageRemoved = (res) => {
    const { chatMessages } = this.state;
    const resChat = chatMessages.find((c) => c.messages.find((m) => m.interactionChatId == res.id));
    if (resChat) {
      let index = chatMessages.indexOf(resChat);
      let messageIndex = resChat.messages.indexOf(resChat.messages.find((r) => r.interactionChatId == res.id));
      if (index > -1 && messageIndex > -1) {
        chatMessages[index].messages[messageIndex].message = res.message;
        this.setState({ chatMessages });
      }
    }
  };
  getEventId = (eventCode) => {
    Axios.get(`./api/event/getId/${eventCode}`)
      .then((res) => {
        this.setState({ eventId: res.data.id }, () => this.connectToHub());
        this.props.dispatch(questionActions.getAllQuestionsByEvent(res.data.id));
      })
      .catch((err) => {
        console.error(err);
      });
  };
  setClientKey = (key) => {
    localStorage.setItem("CLIENT_KEY", key);
  };
  getClientKey = () => {
    return localStorage.getItem("CLIENT_KEY") || null;
  };
  onGetActiveQuestions = (qList) => {
    if (qList.length > 0) {
      let questionIds = qList.map((ql) => {
        return ql.question.questionId;
      });
      this.setState({ activeQuestions: questionIds });
    }
  };
  block = (clientKey, block, eventId) => {
    let extra = {};

    extra.clientKey = clientKey;
    extra.Name = "ChatBlock";
    extra.eventId = eventId;
    extra.value = block ? "True" : "False";

    this.hubConnection.invoke("setInteractionExtra", extra);
  };

  onInteractionExtraSet = (extra) => {
    if (typeof extra == "object") {
      this.interactionExtraHandler(extra);
    } else if (Array.isArray(extra)) {
      extra.map((e) => {
        this.interactionExtraHandler(e);
      });
    }
  };
  interactionExtraHandler = (extra) => {
    if (extra.name == "ChatBlock") {
      const { chatMessages } = this.state;
      const resChat = chatMessages.find((c) => c.eventId == extra.eventId);
      if (resChat) {
        let index = chatMessages.indexOf(resChat);
        if (index > -1) {
          if (extra.value == "True") {
            chatMessages[index].blockedClients.push(extra.clientKey);
          }
          if (extra.value == "False") {
            chatMessages[index].blockedClients = chatMessages[index].blockedClients.filter((x) => x != extra.clientKey);
          }
          this.setState({ chatMessages });
        }
      }
    }
  };
  onSendChatMessage = (message) => {
    const { chatMessages } = this.state;
    const resChat = chatMessages.find((c) => c.eventId == message.eventId);
    if (resChat) {
      let index = chatMessages.indexOf(resChat);
      if (index > -1) {
        chatMessages[index].messages.push(message);
        this.setState({ chatMessages, scroll: true });
        setTimeout(() => this.setState({ scroll: false }), 1500);
      }
    }
  };
  connectToHub = () => {
    const { eventId } = this.state;
    const { user } = this.props;
    try {
      if (!this.hubConnection) {
        this.hubConnection = new HubConnectionBuilder().withUrl("./ihub").build();
      }
    } catch (error) {}
    let clientKey = this.getClientKey();
    this.hubConnection
      .start()
      .then(() => {
        this.hubConnection.on("onHandshake", this.onHandshake);

        this.hubConnection.on("onClearEventData", () => this.setState({ chats: [] }));

        this.hubConnection.on("onMessageRemoved", this.onMessageRemoved);
        this.hubConnection.on("onMessageEdit", this.onMessageEdit);
        this.hubConnection.on("onGetEventChats", this.onGetEventChats);
        this.hubConnection.on("onSendChatMessage", this.onSendChatMessage);
        this.hubConnection.on("onInteractionExtraSet", this.onInteractionExtraSet);
        this.hubConnection.on("onExposeHiddenMessages", this.onExposeHiddenMessages);
        this.hubConnection.on("onClearQuestionAnswers", this.onClearQuestionAnswers);
        this.hubConnection.on("onClearResponses", this.onClearResponses);
        this.hubConnection.onclose(this.onClose);
        this.hubConnection
          .invoke("handshake", {
            eventId,
            clientType: clientTypeConstants.INTERACTION_CHAT_MODERATOR,
            clientKey,
            code: this.state.code,
            userGuid: user ? user.userGuid : null,
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((error) => {});
  };

  onExposeHiddenMessages = () => {
    const c = this.state.chatMessages;

    c.map((c) => {
      return c.messages.map((m) => {
        if (m.receiver === "ALL") {
          m.hidden = false;
        }
      });
    });

    this.setState({ chatMessages: c });
  };

  onGetEventChats = (chatMessages) => this.setState({ chatMessages });
  onRemoveMessage = (id, hide) => this.hubConnection.invoke("removeChatMessage", id, hide);
  onEditMessage = (id, message) => this.hubConnection.invoke("editChatMessage", id, message);
  onClose = () => {
    this.setState({ connected: false });
    if (!window.location.hostname.includes("localhost")) {
      this.connectToHub();
    }
  };

  onForceDisconnect = (res) => {
    if (res === "CODE_NOT_VALID") {
      this.setState({ connected: false, forceDisc: true });
      this.hubConnection.stop();
    }
  };
  onHandshake = (response) => {
    if (response.success) {
      this.hubConnection.invoke("getEventChats", this.state.eventId).catch((err) => {
        console.error(err);
      });
      this.setState({ connected: true, lang: response.lang });
    } else {
      this.setState({ showDialog: true });
    }
  };

  exposeHiddenMessages = (eventId) => {
    this.hubConnection.invoke("exposeHiddenMessages", eventId);
  };

  render() {
    const { chatMessages, connected, forceDisc } = this.state;
    if (!connected && forceDisc) return <NotAuthorized lang={this.state.lang} />;
    const connectionsProps = { hubConnection: this.hubConnection, ...this.state };
    return (
      <div>
        <ChatMessageList
          scroll={this.state.scroll}
          exposeMessages={this.exposeHiddenMessages}
          chatMessages={chatMessages}
          onEditMessage={this.onEditMessage}
          block={this.block}
          lang={this.state.lang}
          onRemoveMessage={this.onRemoveMessage}
        />
        <ConnectionStatus {...connectionsProps} />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    user: state.authentication.user,
  };
}
export default connect(mapStateToProps)(ChatModeratorLayout);

function NotAuthorized(props) {
  return (
    <div>
      <Dialog fullWidth={true} maxWidth={"sm"} open={true} TransitionComponent={Transition} keepMounted aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">
          {" "}
          <React.Fragment>
            <ErrorOutlineIcon />
            {"  "}
            <SystemLabel name="NotAuthorized" lang={props.lang} />
          </React.Fragment>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <SystemLabel name="LinkIsNotValid" lang={props.lang} />
          </DialogContentText>
          <DialogContentText id="alert-dialog-slide-description">
            <SystemLabel name="ContactEventHost" lang={props.lang} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
